export default __webpack_public_path__ + "static/media/cakeLogo.c38e30ff.jpg";